import httpClient from "./httpClient";
import Auth from "./auth.service";
import SMTP from "./smtp.service";
import SERVERS from "./servers.service";
import JSCHEMAS from "./jschemas.service";

/**
 * Use API Factories pattern for managing API
 * Initialize
 */
export const apiFactory = {
  $http: httpClient,
  auth: Auth(httpClient),
  smtp: SMTP(httpClient),
  servers: SERVERS(httpClient),
  jschemas: JSCHEMAS(httpClient),
};

/**
 * Make factory APIs available globally.
 * @param Vue
 */
const setupApi = Vue => {
  Vue.prototype.$api = apiFactory;
};

export default setupApi;



// WEBPACK FOOTER //
// ./src/services/api.js